import { echartLine } from '../common';
import { createLeafletMap, obtenerGeoJson } from '../common-leafletMap';

export function mapPuntosMedidaBicis(vis, datos) {
  document
    .querySelector('#tabPuntsMesuraCiclista')
    .addEventListener('click', () => {
      requestAnimationFrame(() => {
        createLeafletMap(
          'idMapPuntsMesuraCiclista',
          5,
          20,
          14,
          obtenerGeoJson(datos.resultset, 0, 1, 3),
          'build/images/mapas/marker-icon-bicis.svg/content',
          'build/images/mapas/marker-icon-selected-bicis.svg/content',
          'puntoMedidaLaneId',
        );
      });
    });
}

export function echartPuntosMedidaBicis(vis, datos) {
  echartLine(
    datos,
    true,
    -6,
    'TRÀNSIT CICLISTA: PUNTS DE MESURA CICLISTA',
    'Bicicletes',
    'chartPuntsMesuraCiclista',
    'no_dataPuntsMesuraCiclista',
  );
}
